import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Box, MenuItem } from '@mui/material';

import { canStartTrial, canUpgradeAccount } from '../../selectors/users';
import { upgradePlanColorGradient } from './colors';

interface Props extends PropsWithChildren {
  readonly active?: boolean;

  readonly briefDescription: string;
  readonly onUpgradeClick: () => void;
}

const upgradeBorderSx = {
  borderImage: `${upgradePlanColorGradient} 1`,
  borderStyle: 'solid',
  borderWidth: '3px',
};

export function UpgradeMenuItems({ active, briefDescription, onUpgradeClick, children }: Props) {
  const canUpgrade = useSelector(canUpgradeAccount);
  const trialAvailable = useSelector(canStartTrial);

  if (active === false || !canUpgrade) return children;

  return (
    <>
      <Box sx={{ border: upgradeBorderSx }}>{children}</Box>

      <MenuItem
        sx={{
          background: upgradePlanColorGradient,
          '&:hover': {
            filter: (theme) => `brightness(${(1 + theme.palette.action.hoverOpacity) * 100}%)`,
          },

          borderBottom: upgradeBorderSx,
        }}
        onClick={onUpgradeClick}
      >
        {trialAvailable ? `Start your free trial to ${briefDescription}.` : `Upgrade to ${briefDescription}.`}
      </MenuItem>
    </>
  );
}
